import { Outlet, Link } from 'react-router-dom'

export function AuthLayout() {
  return (
    <div
      className="min-h-screen flex flex-col bg-[#1B2A4A] bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: 'url(/auth-bg.jpg)' }}
    >
      {/* Header */}
      <header className="py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/" className="text-2xl font-bold text-white drop-shadow">
            Drive Without Fear
          </Link>
        </div>
      </header>

      {/* Main content */}
      <main className="flex-1 flex items-center justify-center p-4">
        <div className="w-full max-w-[400px]">
          <Outlet />
        </div>
      </main>

      {/* Footer */}
      <footer className="py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-sm text-white/80">
          <Link to="/privacy" className="hover:underline text-white">
            Privacy Policy
          </Link>
          <span className="mx-2">|</span>
          <Link to="/terms" className="hover:underline text-white">
            Terms of Service
          </Link>
        </div>
      </footer>
    </div>
  )
}
